import React from "react";
import parseNumber from "../../../../utils/parseCalculate";
import { Box } from "@mui/material";
import GasDevice from "./Devices/GasDevice";
import { useLiveDevice } from "../../../../hooks/useLiveDeviceData";

function Item(props) {
  const { sx, ...other } = props;
  return <Box {...other} />;
}

const GasWrap = ({ name, deviceId, isExpired }) => {
  const { data, status } = useLiveDevice(isExpired ? null : deviceId, {
    watchStatus: true,
  });
  const deviceStatus = isExpired ? "inactive" : status;

  return (
    <Item>
      <GasDevice
        deviceStatus={deviceStatus}
        deviceId={deviceId}
        ch4Value={isExpired ? "Subscription Expired" : parseNumber(data?.ch4)}
        co2Value={isExpired ? "" : parseNumber(data?.co2)}
        o2Value={isExpired ? "" : parseNumber(data?.o2)}
        h2sValue={isExpired ? "" : parseNumber(data?.h2s)}
        dewPointValue={isExpired ? "" : parseNumber(data?.dew_point)}
        gcvValue={isExpired ? "" : parseNumber(data?.gcv)}
        ncvValue={isExpired ? "" : parseNumber(data?.ncv)}
        n2Value={isExpired ? "" : parseNumber(data?.n2)}
        lastUpdated={
          isExpired
            ? ""
            : `
          ${
            data?.date_time
              ? new Date(data.date_time).toLocaleDateString("en-GB").slice(0, 10)
              : "--"
          } ${
            data?.date_time
              ? new Date(data.date_time).toLocaleTimeString("en-US", {
                  hour12: true,
                })
              : "--"
          }`
        }
        powerStatus={isExpired ? null : data?.battery}
        title={name}
      />
    </Item>
  );
};

export default GasWrap;
